import { Stack, Typography } from '@mui/material';

import { ApiWorkflowDialog, DialogMessageBox } from '@verantos-dev/shared-components';

import { useDeleteCohortModal } from '../../hooks/useDeleteCohortModal';
import { useDeleteCohortModalStrings } from '../../hooks/useDeleteCohortModalStrings';

export const DeleteCohortModal = () => {
  const {
    isDisableDeleteStatus,
    isInUse,
    analyticalDatasets,
    onClose,
    onSubmit,
    isSubmitting,
    isInitialLoading,
    deleteCohortError,
    saveButtonColor,
    isValidForSubmit,
    cohort,
  } = useDeleteCohortModal();
  const { contentMessages, dialogMessages } = useDeleteCohortModalStrings(cohort);

  const renderInUse = (
    <Stack gap={4}>
      <Typography>{contentMessages.inUseDescription}</Typography>
      <Stack component="ul" sx={{ pl: 5, m: 0 }} gap={1}>
        {analyticalDatasets.map((ad) => (
          <Typography component="li" key={ad.analyticalDatasetProfileId}>
            {ad.name}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );

  const renderDeletable = !isDisableDeleteStatus ? (
    <Stack gap={4}>
      <Typography color="error">{contentMessages.actionUndone}</Typography>
      <Typography>{contentMessages.description}</Typography>
    </Stack>
  ) : (
    <Typography>{contentMessages.disableDeleteStatus}</Typography>
  );

  return (
    <ApiWorkflowDialog
      id="deleteCohortModal"
      title={isInUse ? contentMessages.inUseTitle : contentMessages.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      dialogMessages={dialogMessages}
      saveButtonColor={saveButtonColor}
      submittingError={deleteCohortError}
      isInitialLoading={isInitialLoading}
      isValidForSubmit={isValidForSubmit}
      hideDisplayButtonsOnSuccess
    >
      <DialogMessageBox
        id="delete-cohort-message-box"
        title={isInUse ? contentMessages.inUseTitle : contentMessages.confirmTitle}
        type={isInUse ? 'warning' : 'error'}
        variant="outlined"
        renderSubmitted={isInUse ? renderInUse : renderDeletable}
      />
    </ApiWorkflowDialog>
  );
};
